const formatNumberAbbreviate = (n) => {
  const { floor, abs, log, round, min } = Math;
  const abbrev = ['k', 'Mil', 'Bil']; // abbreviations in steps of 1000x; extensible if need to edit

  const rnd = (nInput, precision) => {
    const prec = 10 ** precision;
    return round(nInput * prec) / prec;
  };

  let base = floor(log(abs(n)) / log(1000));
  const suffix = abbrev[min(abbrev.length - 1, base - 1)];
  base = abbrev.indexOf(suffix) + 1;
  return suffix ? rnd(n / 1000 ** base, 2) + suffix : `${n}`;
};

const getDateQuarter = (date = new Date()) => Math.floor(date.getMonth() / 3 + 1);
const getDateMonth = (date = new Date()) => date.getMonth() + 1;
const numberFormatCurrency = (number, currencyType = '') => {
  if (currencyType === null) return Intl.NumberFormat().format(number);

  if (currencyType === '')
    return parseFloat(
      Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(number),
    );

  return new Intl.NumberFormat('en-ph', {
    style: 'currency',
    currency: currencyType,
    maximumSignificantDigits: 2,
    minimumSignificantDigits: 2,
  }).format(number);
};

const paddedPercentage = (number, decimal = 2) =>
  parseFloat(number.toFixed(decimal).replace('.00', ''));
/**
 * Generate a random unique ID
 *
 * @returns {String}
 */
const generateUUID = () => {
  let d = new Date().getTime();

  // Time in microseconds since page-load or 0 if unsupported
  let d2 = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    let r = Math.random() * 16; // random number between 0 and 16
    if (d > 0) {
      // Use timestamp until depleted
      // eslint-disable-next-line no-bitwise
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      // Use microseconds since page-load if supported
      // eslint-disable-next-line no-bitwise
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    // eslint-disable-next-line no-bitwise
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};
/**
 * get the extension of a file from a url
 *
 * @returns {String}
 */
const getUrlExtension = (url = '') => url.split('.').pop();

/**
 * round 2 place for the value
 *
 * @returns {Float}
 */
const toFixed = (value, decimal = 100) => {
  const tmp = parseFloat(value) || 0;
  return Math.round(tmp * decimal) / decimal;
};

export default {
  formatNumberAbbreviate,
  getDateQuarter,
  getDateMonth,
  numberFormatCurrency,
  generateUUID,
  getUrlExtension,
  paddedPercentage,
  toFixed,
};
